// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const phanpy: PokeData = {
  "id": 231,
  "name": "phanpy",
  "height": 5,
  "weight": 335,
  "base_experience": 66,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "defense-curl",
    "flail",
    "endure",
    "charm",
    "rollout",
    "odor-sleuth",
    "natural-gift",
    "last-resort",
    "bulldoze"
  ],
  "moves": [
    "tackle",
    "growl",
    "earthquake",
    "fissure",
    "rototiller",
    "mud-slap",
    "magnitude",
    "earth-power",
    "bonemerang",
    "mud-shot",
    "sandstorm",
    "bone-throw",
    "mud-bomb"
  ],
  "evolution_chain": {
    "id": 119,
    "item": null,
    "species": [
      {
        "name": "phanpy",
        "order": 263,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "donphan",
        "order": 264,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 231,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 70,
    "speed": 40,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
